document.addEventListener('turbolinks:load', () => {
  window.onscroll = function () {
    let toTopButton = document.getElementById("back-to-top")

    if (toTopButton) {
      toTopButton.style.display = window.pageYOffset < 300 ? "none" : ""
    }
  }

  const setCookie = function (cname, cvalue, exdays = 30) {
    let d, expires

    d = new Date()
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
    expires = "expires=" + d.toUTCString()
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"
  }

  $('#cookie-consent-btn').on('click', (evt) => {
    setCookie('cookie_consent_agreement', '1')
    $('#cookie-alert').hide()
  })

  // showcase slide
  let slideIndex = 1

  const nextSlide = (n) => {
    showSlide(slideIndex += n)
  }

  const showSlide = (n) => {
    let imgs = document.querySelectorAll('.slideshow .slideshow__image')
    let caption = document.querySelector('.slideshow .slideshow__caption')
    let i

    if (n > imgs.length) slideIndex = 1
    if (n < 1) slideIndex = imgs.length
    for (i = 0; i < imgs.length; i++) {
      imgs[i].style.display = 'none'
    }
    imgs[slideIndex - 1].style.display = 'block'
    caption.innerHTML = `${slideIndex}/${imgs.length}`
  }

  // Regular slide
  showSlide(slideIndex)

  // Slidehow duration per image
  const duration = 4000 // 4 seconds
  const slideshow = document.querySelector('.slideshow')
  const progressBar = document.querySelector('.slideshow__loading-indicator')

  let interval = 0
  let paused = false

  // Slide with autoplay
  setInterval(() => {
    let diff
    let rect = slideshow.getBoundingClientRect()

    // Start autoplay only when slideshow is visible
    if (rect.top < 0 || rect.top > rect.height) return

    if (paused) {
      interval = duration

      return
    }

    if (interval === duration) {
      nextSlide(1)
      interval = 0
    }

    interval += 1000
    diff = interval / duration * 100
    progressBar.style.width = `${diff}%`
  }, 1000)

  const buttons = [{ dir: 'left', next: -1 }, { dir: 'right', next: 1 }]
  buttons.forEach(btn => {
    $(`.slideshow__button.slideshow__button-${btn.dir}`).on('click', evt => {
      evt.preventDefault()
      evt.stopPropagation()
      nextSlide(btn.next)
      interval = 0
    })
  })

  // Pause event on mouse hover and mouse leave
  slideshow.addEventListener('mouseenter', evt => {
    paused = true
  })

  slideshow.addEventListener('mouseleave', evt => {
    paused = false
  })
})
